import { useState } from 'react'
import * as Tooltip from '@radix-ui/react-tooltip'

import { SquircleAdapter } from '@/components/SquircleAdapter'
import { PriceBy, PriceByProps } from '../PriceBy'

import './styles.scss'
import { useBreakpoints } from '@/hooks'

type OptionProps = {
  value: string
  icon?: React.ReactNode
  selected?: boolean
  onClick?: () => void
  label?: string
  priceBy?: PriceByProps
  description?: string
}

export function Option({
  value,
  icon,
  selected,
  onClick,
  label,
  priceBy,
  description,
}: OptionProps) {
  const [open, setOpen] = useState(false)
  const { isSmall } = useBreakpoints()

  return (
    <Tooltip.Provider delayDuration={1000} disableHoverableContent>
      <Tooltip.Root onOpenChange={setOpen} open={description ? open : false}>
        <Tooltip.Trigger asChild>
          <button
            className="option"
            onClick={() => {
              if (!selected && isSmall) setOpen(true)
              onClick?.()
            }}
            data-selected={selected}
            aria-pressed={selected || false}
          >
            <SquircleAdapter cornerRadius={12} className="option__wrapper">
              <p className="option__wrapper__value">{value}</p>
              {description && <span className="sr-only">{description}</span>}
              {icon && <div className="option__wrapper__icon">{icon}</div>}
              {(label || priceBy) && (
                <div className="option__wrapper__separator">•</div>
              )}
              {label && <div className="option__wrapper__label">{label}</div>}
              {priceBy && <PriceBy {...priceBy} />}
            </SquircleAdapter>
          </button>
        </Tooltip.Trigger>

        <Tooltip.Portal>
          <Tooltip.Content className="tooltip" sideOffset={0}>
            {description}
            <Tooltip.Arrow />
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  )
}
